import React from "react";
import ReactDOM from "react-dom";

import BaseRouter from "./js/Router/BaseRouter.jsx";
import AppConfig from "./js/Configuration/AppConfig";
import RouterHistory from "./js/Router/RouterHistory.js";

import './style/index.scss';

import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { initializeIcons } from '@fluentui/react/lib/Icons'; //(8+)

initializeIcons();

if (!!AppConfig.Logging.ApplicationInsights.instrumentationKey
  && AppConfig.Logging.ApplicationInsights.instrumentationKey !== '') {

  var reactPlugin = new ReactPlugin();
  var appInsights = new ApplicationInsights({
    config: {
      ...AppConfig.Logging.ApplicationInsights,
      extensions: [reactPlugin],
      extensionConfig: {
        [reactPlugin.identifier]: { history: RouterHistory }
      }
    }
  });
  appInsights.loadAppInsights();
}

export { appInsights };

ReactDOM.render(
  <React.StrictMode>
    <BaseRouter />
  </React.StrictMode>,
  document.getElementById('codai-workspace')
);
